/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClientSurveyContactHistoryModel } from '../models/client-survey-contact-history-model';
import { createSurveyContactHistoryAsync$Json } from '../fn/survey-contact-history/create-survey-contact-history-async-json';
import { CreateSurveyContactHistoryAsync$Json$Params } from '../fn/survey-contact-history/create-survey-contact-history-async-json';
import { createSurveyContactHistoryAsync$Plain } from '../fn/survey-contact-history/create-survey-contact-history-async-plain';
import { CreateSurveyContactHistoryAsync$Plain$Params } from '../fn/survey-contact-history/create-survey-contact-history-async-plain';
import { deleteSurveyContactHistoryAsync$Json } from '../fn/survey-contact-history/delete-survey-contact-history-async-json';
import { DeleteSurveyContactHistoryAsync$Json$Params } from '../fn/survey-contact-history/delete-survey-contact-history-async-json';
import { deleteSurveyContactHistoryAsync$Plain } from '../fn/survey-contact-history/delete-survey-contact-history-async-plain';
import { DeleteSurveyContactHistoryAsync$Plain$Params } from '../fn/survey-contact-history/delete-survey-contact-history-async-plain';
import { getSurveyContactHistoriesAsync$Json } from '../fn/survey-contact-history/get-survey-contact-histories-async-json';
import { GetSurveyContactHistoriesAsync$Json$Params } from '../fn/survey-contact-history/get-survey-contact-histories-async-json';
import { getSurveyContactHistoriesAsync$Plain } from '../fn/survey-contact-history/get-survey-contact-histories-async-plain';
import { GetSurveyContactHistoriesAsync$Plain$Params } from '../fn/survey-contact-history/get-survey-contact-histories-async-plain';
import { getSurveyContactHistoryAsync$Json } from '../fn/survey-contact-history/get-survey-contact-history-async-json';
import { GetSurveyContactHistoryAsync$Json$Params } from '../fn/survey-contact-history/get-survey-contact-history-async-json';
import { getSurveyContactHistoryAsync$Plain } from '../fn/survey-contact-history/get-survey-contact-history-async-plain';
import { GetSurveyContactHistoryAsync$Plain$Params } from '../fn/survey-contact-history/get-survey-contact-history-async-plain';

@Injectable({ providedIn: 'root' })
export class SurveyContactHistoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSurveyContactHistoriesAsync()` */
  static readonly GetSurveyContactHistoriesAsyncPath = '/api/SurveyContactHistory';

  /**
   * get list of surveycontacthistory.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyContactHistoriesAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactHistoriesAsync$Plain$Response(params: GetSurveyContactHistoriesAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyContactHistoryModel>>> {
    return getSurveyContactHistoriesAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get list of surveycontacthistory.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyContactHistoriesAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactHistoriesAsync$Plain(params: GetSurveyContactHistoriesAsync$Plain$Params, context?: HttpContext): Observable<Array<ClientSurveyContactHistoryModel>> {
    return this.getSurveyContactHistoriesAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientSurveyContactHistoryModel>>): Array<ClientSurveyContactHistoryModel> => r.body)
    );
  }

  /**
   * get list of surveycontacthistory.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyContactHistoriesAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactHistoriesAsync$Json$Response(params: GetSurveyContactHistoriesAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyContactHistoryModel>>> {
    return getSurveyContactHistoriesAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get list of surveycontacthistory.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyContactHistoriesAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactHistoriesAsync$Json(params: GetSurveyContactHistoriesAsync$Json$Params, context?: HttpContext): Observable<Array<ClientSurveyContactHistoryModel>> {
    return this.getSurveyContactHistoriesAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientSurveyContactHistoryModel>>): Array<ClientSurveyContactHistoryModel> => r.body)
    );
  }

  /** Path part for operation `createSurveyContactHistoryAsync()` */
  static readonly CreateSurveyContactHistoryAsyncPath = '/api/SurveyContactHistory';

  /**
   * create surveycontacthistory item.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSurveyContactHistoryAsync$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyContactHistoryAsync$Plain$Response(params?: CreateSurveyContactHistoryAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyContactHistoryModel>> {
    return createSurveyContactHistoryAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * create surveycontacthistory item.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSurveyContactHistoryAsync$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyContactHistoryAsync$Plain(params?: CreateSurveyContactHistoryAsync$Plain$Params, context?: HttpContext): Observable<ClientSurveyContactHistoryModel> {
    return this.createSurveyContactHistoryAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyContactHistoryModel>): ClientSurveyContactHistoryModel => r.body)
    );
  }

  /**
   * create surveycontacthistory item.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSurveyContactHistoryAsync$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyContactHistoryAsync$Json$Response(params?: CreateSurveyContactHistoryAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyContactHistoryModel>> {
    return createSurveyContactHistoryAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * create surveycontacthistory item.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSurveyContactHistoryAsync$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyContactHistoryAsync$Json(params?: CreateSurveyContactHistoryAsync$Json$Params, context?: HttpContext): Observable<ClientSurveyContactHistoryModel> {
    return this.createSurveyContactHistoryAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyContactHistoryModel>): ClientSurveyContactHistoryModel => r.body)
    );
  }

  /** Path part for operation `getSurveyContactHistoryAsync()` */
  static readonly GetSurveyContactHistoryAsyncPath = '/api/SurveyContactHistory/{surveyContactHistoryId}';

  /**
   * get surveycontacthistory by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyContactHistoryAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactHistoryAsync$Plain$Response(params: GetSurveyContactHistoryAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyContactHistoryModel>> {
    return getSurveyContactHistoryAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get surveycontacthistory by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyContactHistoryAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactHistoryAsync$Plain(params: GetSurveyContactHistoryAsync$Plain$Params, context?: HttpContext): Observable<ClientSurveyContactHistoryModel> {
    return this.getSurveyContactHistoryAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyContactHistoryModel>): ClientSurveyContactHistoryModel => r.body)
    );
  }

  /**
   * get surveycontacthistory by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyContactHistoryAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactHistoryAsync$Json$Response(params: GetSurveyContactHistoryAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyContactHistoryModel>> {
    return getSurveyContactHistoryAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get surveycontacthistory by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyContactHistoryAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyContactHistoryAsync$Json(params: GetSurveyContactHistoryAsync$Json$Params, context?: HttpContext): Observable<ClientSurveyContactHistoryModel> {
    return this.getSurveyContactHistoryAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyContactHistoryModel>): ClientSurveyContactHistoryModel => r.body)
    );
  }

  /** Path part for operation `deleteSurveyContactHistoryAsync()` */
  static readonly DeleteSurveyContactHistoryAsyncPath = '/api/SurveyContactHistory/{surveyContactHistoryId}';

  /**
   * delete survey contact history by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSurveyContactHistoryAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyContactHistoryAsync$Plain$Response(params: DeleteSurveyContactHistoryAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return deleteSurveyContactHistoryAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * delete survey contact history by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSurveyContactHistoryAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyContactHistoryAsync$Plain(params: DeleteSurveyContactHistoryAsync$Plain$Params, context?: HttpContext): Observable<number> {
    return this.deleteSurveyContactHistoryAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /**
   * delete survey contact history by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSurveyContactHistoryAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyContactHistoryAsync$Json$Response(params: DeleteSurveyContactHistoryAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return deleteSurveyContactHistoryAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * delete survey contact history by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSurveyContactHistoryAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyContactHistoryAsync$Json(params: DeleteSurveyContactHistoryAsync$Json$Params, context?: HttpContext): Observable<number> {
    return this.deleteSurveyContactHistoryAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

}
